import type { SVGProps } from 'react';
const SvgTextRotationNone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#text_rotation_none_svg__a)">
      <path
        fill="currentColor"
        d="M12.75 3h-1.5L6.5 14h2.1l.9-2.2h5l.9 2.2h2.1L12.75 3Zm-2.62 7L12 4.98 13.87 10h-3.74Zm10.37 8-3-3v2H5v2h12.5v2l3-3Z"
      />
    </g>
    <defs>
      <clipPath id="text_rotation_none_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTextRotationNone;
